"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalProgressBar = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const assets_1 = require("../../assets");
const HorizontalProgressBar = ({ progress, numResponses, isCorrect, title, imgSrc, description, blurred, }) => {
    const fullBarStyles = {
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        opacity: blurred ? '0.5' : '1',
    };
    const backgroundBarStyles = {
        width: `${progress}%`,
        height: '100%',
        minHeight: '5rem',
        backgroundColor: isCorrect ? '#1F794C' : '#444A67',
        transition: 'width 0.5s ease-out',
        borderRadius: '0.5rem',
        position: 'relative',
        display: 'flex',
    };
    const imageTextContainerStyles = {
        height: '80%',
        marginLeft: '1rem',
        position: 'absolute',
        top: '50%',
        transform: 'translate(0%, -50%)',
        display: 'flex',
        gap: '0.5rem',
    };
    return (react_1.default.createElement("div", { style: fullBarStyles },
        react_1.default.createElement("div", { style: backgroundBarStyles },
            react_1.default.createElement("div", { style: imageTextContainerStyles },
                imgSrc && (react_1.default.createElement("img", { src: imgSrc, style: {
                        borderRadius: '0.23rem',
                        width: 'auto',
                        border: isCorrect && numResponses === 0
                            ? '5px solid #1F794C'
                            : 'none',
                        boxSizing: 'border-box',
                        WebkitBoxSizing: 'border-box',
                    } })),
                !imgSrc && (react_1.default.createElement("div", { style: {
                        alignSelf: 'center',
                        whiteSpace: 'nowrap',
                    } },
                    react_1.default.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '0.5rem',
                            alignItems: 'center',
                        } },
                        react_1.default.createElement(material_1.Typography, { sx: {
                                color: 'white',
                                fontWeight: 500,
                                lineHeight: '1.5rem',
                                fontSize: '1rem',
                            } }, title),
                        isCorrect && assets_1.CheckMark),
                    react_1.default.createElement(material_1.Typography, { sx: {
                            color: 'white',
                            lineHeight: '1rem',
                            fontSize: '0.8rem',
                        } }, description))))),
        react_1.default.createElement("div", { style: { color: 'white' } }, numResponses)));
};
exports.HorizontalProgressBar = HorizontalProgressBar;
